import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BrowserHistoryLock from './components/BrowserHistoryLock';
import LandingPage   from './pages/LandingPage';
import MeetingRoom   from './pages/LiveKitRoom';
import VoiceAgentPage from './pages/VoiceAgentPage';
import BotAdminLogin from './pages/bot-admin/BotAdminLogin';
import BotAdminDashboard from './pages/bot-admin/BotAdminDashboard';
import './App.css';

function App() {
  return (
    <Router>
      <BrowserHistoryLock />
      <div className="App">
        <Routes>
          <Route path="/"               element={<LandingPage />} />
          <Route path="/meeting/room"   element={<MeetingRoom />} />
          <Route path="/voice-agent"    element={<VoiceAgentPage />} />
          <Route path="/bot-admin/login" element={<BotAdminLogin />} />
          <Route path="/bot-admin" element={<BotAdminDashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
